<template>
  <div class="header mid1200">
    <div class="left">
      <img src="../public/img/login_logo.png" alt @click="link('home',0)" class="fl poi" />
      <div class="nav">
        <span class="btn poi" @click="link('companyMsg','companyMsg')">
          <i class="el-icon-setting"></i>信息管理
        </span>
        <span class="btn poi" @click="link('zsApply','zsApply')">
          <i class="el-icon-search"></i>数据查询
        </span>
        <span v-if="saas" class="btn poi" @click="saasGo">SAAS服务入口</span>
      </div>
    </div>
    <ul class="right">
      <li
        v-show="token"
        v-for="(item, index) in nav"
        @click="routerLink(index, item.path)"
        :key="index"
        :class=" navIndex == index ? 'btn active poi' : 'btn poi'"
      >{{ item.title }}</li>
    </ul>
    <div
      v-if="!token && user!=null"
      class="flex margin-left-auto align-center poi backmine justify-end"
      @click="usergo"
    >
      <img class="radius-50p _cover" :src="user.logo!=null && user.logo?user.logo:$nodata" alt />
      <div class="user_name text-cut-two">{{user.e_name!=null && user.e_name?user.e_name:'企业名称'}}</div>
      <div class="backlogin">
        <div @click.stop="cardGO">查看我的名片</div>
        <div @click.stop="backlogin">退出登陆</div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.header {
  height: 80px;
  line-height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header .left {
  /* width: 500px; */
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.nav {
  margin-left: 80px;
}

.nav .btn {
  display: inline-block;
  width: 140px;
  text-align: center;
  color: #333;
  height: 80px;
  font-size: 18px;
  margin-left: 10px;
}

.nav .btn i {
  margin-right: 10px;
  font-size: 20px;
}

.header .right {
  font-size: 0;
}

.header .right .btn {
  display: inline-block;
  font-size: 16px;
  color: #333333;
  height: 35px;
  line-height: 35px;
  width: 60px;
  background: #ececec;
  text-align: center;
}

._cover {
}

.header .right .btn.active {
  background: #ff6633;
  color: #fff;
}
.backmine {
  position: relative;
  margin-left: auto;
  min-width: 100px;
}
.backmine:hover .backlogin {
  display: block;
}
.backlogin:hover {
  display: block;
}
.backlogin {
  display: none;
  width: 200px;
  height: auto;
  text-align: center;
  position: absolute;
  bottom: -180%;
  right: 50%;
  transform: translateX(50%);
  z-index: 999;
  background: white;
  box-shadow: 0 0 5px #cccccc;
  color: black;
  border-radius: 2px;
  line-height: 1;
}
.backlogin div {
  padding: 15px 0;
}
.backmine img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin: 0 5px;
  margin-right: 20px !important;
}
</style>
<script>
export default {
  data() {
    return {
      nav: [
        {
          title: "登录",
          path: "/login"
        },
        {
          title: "注册",
          path: "/register"
        }
      ],
      user: "",
      navIndex: 0,
      token: window.localStorage.getItem("pc_token") ? false : true,
      saas: ""
    };
  },
  watch: {
    $route() {
      this.user = JSON.parse(window.localStorage.getItem("ent_info"));
    }
  },
  created() {
    if (window.localStorage.getItem("pc_token")) {
      this.post(this, "/home/getEntinfo", {
        token: window.localStorage.getItem("pc_token")
      }).then(res => {
        window.localStorage.setItem(
          "ent_info",
          JSON.stringify(res.data.data.ent_info)
        );
        window.localStorage.setItem(
          "level",
          res.data.data.function_choice ? res.data.data.function_choice : false
        );
      });
      this.user = JSON.parse(window.localStorage.getItem("ent_info"));
      this.getSaas();
    }
  },
  mounted() {
    console.log(this.$route.path); //* /login
    if (this.$route.path == "/login") {
      this.navIndex = 0;
    } else {
      this.navIndex = 1;
    }
  },
  methods: {
    getSaas() {
      this.post(this, "/wap/index/online/trade", {
        enterprise_id: window.localStorage.getItem("e_id")
      }).then(res => {
        if (res.data.code == 0) {
          this.saas = res.data.url;
        }
      });
    },
    // saas
    saasGo() {
      window.open(this.saas, "_blank");
    },
    /**
     * 路由跳转
     * @param index
     * @param link
     */
    routerLink(index, path) {
      // 点击哪个路由就赋值给自定义的下下标
      this.navIndex = index;
      // 路由跳转
      this.$router.push(path);
    },
    link(res, i) {
      if (i != 0) {
        if (window.localStorage.getItem("pc_token")) {
          //判断是否登录
          if (window.localStorage.getItem("step") == 1) {
            //未完善强制跳转到完善页
            this.$router.push({
              name: "register",
              query: { step: 2, pointAddress: i }
            });
          } else {
            this.$router.push({ name: res }); //登录之后跳转
          }
        } else {
          this.$router.push({
            name: "login",
            query: { step: 2, pointAddress: i }
          });
        }
      } else {
        this.$router.push({ name: res });
      }
    },
    backlogin() {
      this.post(this, "/home/quitLogin", {
        token: window.localStorage.getItem("pc_token")
      }).then(res => {
        if (res.data.code == 0) {
          this.$message.success("退出成功");
          window.localStorage.removeItem("pc_token");
          window.localStorage.removeItem("remembeLogin");
          window.localStorage.removeItem("level");
          window.localStorage.removeItem("ent_info");
          window.localStorage.removeItem("step");
          window.localStorage.removeItem("aside");
          window.localStorage.removeItem("asides");
          this.$router.push({ name: "login" });
        }
      });
    },
    usergo() {
      this.post(this, "/home/getEntinfo", {
        token: window.localStorage.getItem("pc_token")
      }).then(res => {
        if (res.data.data.is_perfect == 1) {
          //未完善强制跳转到完善页
          this.$router.push({
            name: "register",
            query: { step: 2, pointAddress: "mine" }
          });
        } else {
          if (window.localStorage.getItem("step")) {
            this.$router.push({
              name: "mine"
            });
          } else {
            //未完善强制跳转到完善页
            this.$router.push({
              name: "register",
              query: { step: 2, pointAddress: "mine" }
            });
          }
        }
      });
    },
    // 手机端
    cardGO() {
      window.open(
        "http://www.ilianpei.com/card?id=" +
          window.localStorage.getItem("e_id"),
        "_blank"
      );
    }
  }
};
</script>
